import React from 'react';
import { Box, Button, Typography } from 'web-library';
import IconWithLabel from 'web-library/stories/atom/IconWithLabel/IconWithLabel';
import { CancelOutlined } from '@mui/icons-material';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import { IStylingAndTranslationHooks } from './model';

const StartFileProcessingErrorVisualLabel = ({
  classes,
  translation: t,
}: IStylingAndTranslationHooks) => (
  <Box className={classes.uploadErrorSection}>
    <CancelOutlined className={classes.errorIcon} />
    <Typography variant="body1" className={classes.uploadErrorDescription}>
      {t('exam->>UploadExcelTemplate.StartFileProcessingErrorDescription')}
    </Typography>
  </Box>
);

interface StartFileProcessingErrorActionLabelProps extends IStylingAndTranslationHooks {
  errorFileDownloadUrl?: string;
}

const StartFileProcessingErrorActionLabel = ({
  translation: t,
  errorFileDownloadUrl,
}: StartFileProcessingErrorActionLabelProps) => {
  const downloadErrorsFileHandler = () =>
    errorFileDownloadUrl && window.open(errorFileDownloadUrl, '_blank');

  return (
    <Box>
      <Button variant="text" onClick={downloadErrorsFileHandler} color="primary">
        <IconWithLabel
          iconSize="M"
          iconName={IconName.download}
          label={t('components->>ErrorFile.DownloadErrorFile')}
          typographyProps={{
            variant: 'h5',
          }}
        />
      </Button>
    </Box>
  );
};

export { StartFileProcessingErrorVisualLabel, StartFileProcessingErrorActionLabel };
